import React from 'react'
import { Grid, GridColumn, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import "./Menu.scss";

export function Menu() {
    return (
        <div className='footer-menu'>
            <h4>Navegacion</h4>

            <Grid columns={2}>
                <Grid.Column>
                    <Link to="https://github.com/RETBOT" >
                        <Icon name='book' />Cursos online
                    </Link>
                    <Link to="https://github.com/RETBOT/Web-Stack-MERN" >
                        <Icon name='code' />Desarollo web
                    </Link>
                    <Link to="https://github.com/RETBOT/ADMINISTRACION-DE-BASE-DE-DATOS" >
                        <Icon name='database' />Base de datos
                    </Link>
                    <Link to="https://github.com/RETBOT?tab=repositories" >
                        <Icon name='code' />UI/UX
                    </Link>
                </Grid.Column>
                <GridColumn>
                    <Link to="https://github.com/RETBOT/TALLER-DE-BASE-DE-DATOS" >
                        <Icon name='server' />sistemas / servidores
                    </Link>
                    <Link to="https://github.com/RETBOT/TiendaWebJS" >
                        <Icon name='cogs' /> CMS
                    </Link>
                    <Link to="https://github.com/RETBOT?tab=repositories" >
                        <Icon name='user outline' /> Portafolio
                    </Link>
                    <Link to="https://github.com/RETBOT/Django-X-Linux" >
                        <Icon name='python' /> Backend
                    </Link>

                </GridColumn>
            </Grid>
        </div>
    )
}
